module.exports = __webpack_public_path__ + "static/ro-trainings-3-4a13700663642a7f35377a8f910f326a.jpg";